function updateCustomTables(value) {
	return {
		type: 'UPDATE_CUSTOM_TABLE',
		payLoad: {
			value
		}
	}
}

export {updateCustomTables};